<template>
  <div class="rounded-md relative aspect-video w-full overflow-hidden">
    <RevIllustration
      :src="article.image"
      :width="1600"
      :height="900"
      alt=""
      aria-hidden="true"
      loading="lazy"
      class="h-full w-full object-cover"
    />

    <button
      type="button"
      class="group absolute inset-0 grid cursor-pointer place-items-center"
      :aria-label="i18n(translations.readLabel, { title: i18n(article.title) })"
      @click="$emit('open')"
    >
      <span
        aria-hidden="true"
        class="raw-glass raw-cta-3 rounded-full px-16 py-8 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] group-hover:bg-[white]/80"
      >
        {{ i18n(translations.readMore) }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import type { Article } from '~/scopes/campaign/data/articles/data'

import translations from './ArticleTile.translations'

// `NativeVideo`'s inline box with the play glyph swapped for a label, so a story
// and a film are the same rectangle; the list owns navigation and tracking.
defineProps<{ article: Article }>()
defineEmits<{ open: [] }>()

const i18n = useI18n()
</script>
